import styled, { css } from 'styled-components';

export const Container = styled.div`
    display: flex;
    ${({ isOpen }) => isOpen &&
        css`
            width: 100%;
            height: 3rem;
            justify-content: center;
            align-items: center;
            background: #ffffff;
            box-shadow: 0 1px 1px #ccc;
            border-radius: 6px;

            ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') && css`
                border: 3px solid #000000;
            `}
        `
    };
       @keyframes go-back {
        from {
            transform: translateX(600px);
        };
        to {
            transform: translateX(0);
        };
    };
`;
export const Content = styled.div`
   display: flex;
   width: 20rem;
   height: 3rem;
   border-radius: 6px;
   align-items: center;
   justify-content: space-between;
   padding: 0 0.5rem 0 0.5rem;
  
   ${(props) => (props.isDisabled &&
        css`
            pointer-events: none;
            opacity: 0.3;
        `
    )};

    .time{
        display: flex;
        justify-content: center;
        align-items: center;
        max-width: 15rem;

        span{
            display: flex;
            width: 40px;
            height: 40px;
            justify-content: center;
            align-items: center;
            color: #999;
        }
    }
`;
export const Icon = styled.span`
    display: flex;
    width: 40px;
    height: 40px;
    justify-content: center;
    align-items: center;
    font-size: 1.3rem;
    color: #919191;
    

    &:hover{
        color: #1c83e2;
    };

    .default{
        cursor: pointer;
    };

    .trash{
        font-size: 1.7rem;
        color: #ff0000;
        cursor: pointer;
    };

    .trash:hover{
        color: #ff000091;

    }

    .save{
        color: #03d755;
        font-size: 1.7rem;
        cursor: pointer;
    };

    .save:hover{
        color: #03d75591;
    };

    .sendVoice{
        font-size: 2.2rem;
        padding: 0.4rem;
        cursor: pointer;
        color: #ffffff;
        border-radius: 4px;
        background-color: #1b72d6;

        ${({ accessLevel }) => accessLevel?.includes('ACESSIBILIDADE') && css`
            background-color: #ffffff;
            color: #000000;
            border: 2px solid #000000;
        `}
    };

    .activeMic{
        color: #f5f5f5;
        font-size: 1.2rem;
    };

    .blob-recorder{
      display: flex;
      justify-content: center;
      align-items: center;
      border-radius: 50%;
      height: 15px;
      width: 15px;
      transform: scale(1);
      background: #ff0000;
      box-shadow: 0 0 0 0  #ff0000;
      animation: pulse-s 2s infinite;
      @keyframes pulse-s {
        0% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba(255,0,0, 0.7);
        }
        70% {
          transform: scale(1);
          box-shadow: 0 0 0 10px rgba(255,0,0, 0);
        }
        100% {
          transform: scale(0.95);
          box-shadow: 0 0 0 0 rgba(255,0,0, 0);
        }
      }
    }
`;
export const VoicePreview = styled.audio`
    width: 13.5rem;
    height: 2.7rem;
`;
export const LoadSend = styled.div`
    border: 1px solid transparent;
    border-radius: 50%;
    border-top: 2px solid #3498db;
    width: 2rem;
    height: 2rem;
    animation: spin 1.4s linear infinite;

    @keyframes spin {
        0% { transform: rotate(0deg); }
        100% { transform: rotate(360deg); }
    }

`;